import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

import HistoryRouter from 'src/routes/components/history-router';

import App from './app';
// import './config-sentry';
// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <HelmetProvider>
    <HistoryRouter>
      <Suspense>
        <App />
      </Suspense>
    </HistoryRouter>
  </HelmetProvider>
);
